namespace Areas.Building.Drawing {
    "use strict";

    $(() => { init(); });

    function init() {
        const $container = $("#checkboxFilterContainerBuildingDrawings");

        if ($container.length) {
            const template = $("#checkboxList").html();

            $.get("/Building/Drawing/GetDrawingTypes", function (data) {
                const items = Areas.partitionBy(data, 4);
                $container.append(_.template(template)({ items: items }));
            });
        }
    }  
    
    export function downloadDrawingLink(cellElement: any, cellInfo: any) {
        var buildingId = cellInfo.component.option("buildingId");
        var content = `<a href= '/File/Get/Drawing/${cellInfo.data.drawingId}?buildingId=${buildingId}'>Download</a>`;
        cellElement.html(content);
    }    

    export function applyFilter() {
        $("#DrawingDataGrid").dxDataGrid("instance").refresh();
    }

    export function getDrawingTypes() {
        var drawingTypes = [];
        $.each($("input[name='drawing-type']:checked"), function(){            
            drawingTypes.push($(this).val());
        });

        return drawingTypes.join("|");
    } 
    
    export function getFilterType() {
        return false;
    } 
        
}